export default "__VITE_ASSET__Dumk7QMh__"